/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _circle4, _path149, _path150, _path151, _circle5, _path152, _path153, _path154, _circle6, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _circle7, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _circle8, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _circle9, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _circle0, _path295, _path296;
const didWarnAboutDeprecation = {};
const DatabaseRedis = /*#__PURE__*/React.forwardRef(function DatabaseRedis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7156,22h-.115a3.371,3.371,0,0,1-3.3113,2.2764c-3.0124,0-4.6912-2.2764-4.6912-6.3006,0-4.0012,1.6788-6.2546,4.6912-6.2546a3.3049,3.3049,0,0,1,3.3113,2.2534h.115v-6.99h2.9433V24H25.7156Zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556,2.556,0,0,0,20.68,16.9636v2.07a2.5365,2.5365,0,0,0,2.5522,2.8052C24.6348,21.8384,25.7156,21.1257,25.7156,19.8838Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5576,24H3.5222V7.95h7.2434c2.92,0,4.7371,1.9316,4.7371,4.967a4.4237,4.4237,0,0,1-2.9893,4.553L15.8018,24h-3.38L9.4321,17.8145H6.5576Zm3.9092-8.738a1.6888,1.6888,0,0,0,1.8855-1.8167V12.3875a1.6722,1.6722,0,0,0-1.8855-1.7935H6.5576v4.668Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DatabaseRedis.propTypes = iconPropTypes;
}
const Datastore = /*#__PURE__*/React.forwardRef(function Datastore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "23",
    r: "1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H20V24H8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "9",
    r: "1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H20V10H8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Datastore.propTypes = iconPropTypes;
}
const Db2BufferPool = /*#__PURE__*/React.forwardRef(function Db2BufferPool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 31L24.602 30 26.8895 26 23 26 26.993 19 28.73 20 26.4463 24 30.3367 24 26.338 31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H12V16H8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H24V16H20z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H18V24H14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5,11H27v5h2V5c0-1.1025-.8972-2-2-2H5c-1.1028,0-2,.8975-2,2V27c0,1.1025,.8972,2,2,2h15v-2H5V11ZM27,5v4H5V5H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Db2BufferPool.propTypes = iconPropTypes;
}
const Db2DataSharingGroup = /*#__PURE__*/React.forwardRef(function Db2DataSharingGroup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28v-6.1699l2.5898,2.5801,1.4102-1.4102-5-5-5,5,1.4102,1.4102,2.5898-2.5801v6.1699c0,1.1025,.8972,2,2,2h9v-2H8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25,17c-2.8506,0-5,1.29-5,3v7c0,1.71,2.1494,3,5,3s5-1.29,5-3v-7c0-1.71-2.1494-3-5-3Zm0,2c1.936,0,3,.751,3,1s-1.064,1-3,1-3-.751-3-1,1.064-1,3-1Zm0,9c-1.936,0-3-.751-3-1v-4.5796c.8264,.3623,1.8508,.5796,3,.5796s2.1736-.2173,3-.5796v4.5796c0,.249-1.064,1-3,1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5898,7.5898l-2.5898,2.5801V4c0-1.1025-.8972-2-2-2H15v2h9v6.1699l-2.5898-2.5801-1.4102,1.4102,5,5,5-5-1.4102-1.4102Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7,15c2.8506,0,5-1.29,5-3V5c0-1.71-2.1494-3-5-3S2,3.29,2,5v7c0,1.71,2.1494,3,5,3Zm0-11c1.936,0,3,.751,3,1s-1.064,1-3,1-3-.751-3-1,1.064-1,3-1Zm-3,3.4204c.8264,.3623,1.8508,.5796,3,.5796s2.1736-.2173,3-.5796v4.5796c0,.249-1.064,1-3,1s-3-.751-3-1V7.4204Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Db2DataSharingGroup.propTypes = iconPropTypes;
}
const Db2Database = /*#__PURE__*/React.forwardRef(function Db2Database({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3c-5.2979,0-11,1.252-11,4V25c0,2.748,5.7021,4,11,4s11-1.252,11-4V7c0-2.748-5.7021-4-11-4Zm0,2c5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8413,0-8.8394-1.4556-9-1.9824v-.0049c.1606-.5571,3.1587-2.0127,9-2.0127ZM7,9.4277c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm0,6c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723Zm9,11.5723c-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596c-.1606,.5571-3.1587,2.0127-9,2.0127Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Db2Database.propTypes = iconPropTypes;
}
const Debug = /*#__PURE__*/React.forwardRef(function Debug({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Debug.propTypes = iconPropTypes;
}
const DecisionNode = /*#__PURE__*/React.forwardRef(function DecisionNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2v8h-4L16,2l-8,8h-4V2h-2v8c0,1.1025.8972,2,2,2h4l7,7v7.1719l-2.5859-2.5859-1.4141,1.4141,5,5,5-5-1.4141-1.4141-2.5859,2.5859v-7.1719l7-7h4c1.1028,0,2-.8975,2-2V2h-2Zm-12,15.1714l-6.1714-6.1714,6.1714-6.1714,6.1714,6.1714-6.1714,6.1714Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DecisionNode.propTypes = iconPropTypes;
}
const DecisionTree = /*#__PURE__*/React.forwardRef(function DecisionTree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DecisionTree.propTypes = iconPropTypes;
}
const Delete = /*#__PURE__*/React.forwardRef(function Delete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m29,26H12c-.2651,0-.5195-.1053-.707-.2928L2.293,16.7072c-.3906-.3906-.3906-1.0237,0-1.4143L11.293,6.2928c.1875-.1875.4419-.2928.707-.2928h17c.5522,0,1,.4478,1,1v18c0,.5522-.4478,1-1,1Zm-16.5857-2h15.5857V8h-15.5857l-8,8,8,8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 16L25 11.4141 23.5859 10 19 14.5859 14.4143 10 13 11.4141 17.5859 16 13 20.5859 14.4143 22 19 17.4141 23.5859 22 25 20.5859 20.4141 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Delete.propTypes = iconPropTypes;
}
const Delivery = /*#__PURE__*/React.forwardRef(function Delivery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H16V18H4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H12V13H2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Delivery.propTypes = iconPropTypes;
}
const DeliveryAdd = /*#__PURE__*/React.forwardRef(function DeliveryAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeliveryAdd.propTypes = iconPropTypes;
}
const DeliveryParcel = /*#__PURE__*/React.forwardRef(function DeliveryParcel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H10V16H2z",
    transform: "rotate(-180 6 15)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H12V24H4z",
    transform: "rotate(-180 8 23)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H14V20H6z",
    transform: "rotate(-180 10 19)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeliveryParcel.propTypes = iconPropTypes;
}
const DeliverySettings = /*#__PURE__*/React.forwardRef(function DeliverySettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189,18.6064l-3-7c-.1572-.3682-.5186-.6064-.9189-.6064h-3v-2c0-.5527-.4473-1-1-1h-3v2h2v12.5562c-.9094.5308-1.5869,1.4009-1.858,2.4438h-6.2841c-.447-1.7207-1.9993-3-3.8579-3s-3.4109,1.2793-3.8579,3h-1.1421v-8h-2v9c0,.5527.4473,1,1,1h2.1421c.447,1.7207,1.9993,3,3.8579,3s3.4109-1.2793,3.8579-3h6.2841c.4472,1.7207,1.9997,3,3.858,3s3.4108-1.2793,3.858-3h2.142c.5527,0,1-.4473,1-1v-7c0-.1401-.0293-.2725-.0811-.3936ZM9,28c-1.1025,0-2-.8975-2-2s.8975-2,2-2,2,.8975,2,2-.8975,2-2,2ZM23,13h2.3408l2.1431,5h-4.4839v-5ZM23,28c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2ZM28,25h-1.142c-.4472-1.7207-1.9997-3-3.858-3v-2h5v5ZM4.833,11.7529l-1.49,1.4901,1.414,1.414,1.49-1.4901c.5318.3546,1.127.6031,1.753.7321v2.1011h2v-2.1011c.626-.129,1.2211-.3775,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49c.3545-.5318.603-1.127.732-1.753h2.1011v-2h-2.1011c-.129-.6259-.3774-1.2211-.7319-1.7529l1.4901-1.4901-1.414-1.414-1.4901,1.4901c-.5318-.3546-1.127-.6031-1.753-.7321V2h-2v2.1011c-.6259.129-1.2211.3775-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49c-.3545.5318-.603,1.127-.732,1.753H2v2h2.1011c.1289.6259.3774,1.2211.7319,1.7529ZM9,6c1.6569,0,3,1.3431,3,3-.0018,1.6561-1.3439,2.9982-3,3-1.6569,0-3-1.3431-3-3s1.3431-3,3-3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeliverySettings.propTypes = iconPropTypes;
}
const DeliveryTruck = /*#__PURE__*/React.forwardRef(function DeliveryTruck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeliveryTruck.propTypes = iconPropTypes;
}
const Demo = /*#__PURE__*/React.forwardRef(function Demo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2L20 14 30 8 20 2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m28,14v8H4V6h10v-2H4c-1.1045,0-2,.8955-2,2v16c0,1.1045.8955,2,2,2h8v4h-4v2h16v-2h-4v-4h8c1.1046,0,2-.8955,2-2v-8h-2Zm-10,14h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Demo.propTypes = iconPropTypes;
}
const WatsonHealthDenominate = /*#__PURE__*/React.forwardRef(function WatsonHealthDenominate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H19a3,3,0,0,0-3,3v2h2V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V26A3,3,0,0,0,25,23Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18a4,4,0,1,0,4-4A4,4,0,0,0,18,18Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,24,18Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDenominate.propTypes = iconPropTypes;
}
const Departure = /*#__PURE__*/React.forwardRef(function Departure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.48,5.15l5.69,8.14.8,1.15,1.35-.36,4.52-1.21a2.13,2.13,0,0,1,1.12,0A1.84,1.84,0,0,1,28.23,14,1.87,1.87,0,0,1,27,16.45l-18.71,5a1.78,1.78,0,0,1-1,0A1.87,1.87,0,0,1,6,20.12l-.25-.93L5,16.38l-.74-2.74,1.44-.39L8,16.35l.81,1.08,1.31-.35,2.8-.75,1.94-.52-.52-1.93L12.08,5.52l1.4-.37M14.16,3a1.06,1.06,0,0,0-.5,0l-3.09.83A1,1,0,0,0,9.89,5l2.5,9.36-2.81.75L6.85,11.5a1,1,0,0,0-.52-.36,1.06,1.06,0,0,0-.5,0L2.72,12A1,1,0,0,0,2,13.16L3,16.9l.75,2.8.25.94a3.87,3.87,0,0,0,2.74,2.74,3.91,3.91,0,0,0,2,0l18.7-5a3.84,3.84,0,0,0,0-7.44,4.27,4.27,0,0,0-2.16,0l-4.51,1.21L14.7,3.41A1,1,0,0,0,14.16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Departure.propTypes = iconPropTypes;
}
const Dependency = /*#__PURE__*/React.forwardRef(function Dependency({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051,16.3956l-3.5975,3.5977-1.4142-1.4142,3.5976-3.5976M10.5792,20l-3.5792,3.5791,1.4075,1.4209,3.5925-3.5926M5.5792,25l-3.5792,3.5791,1.4075,1.4209,3.5925-3.5926M20.6015,9.971l-3.6081,3.6081,1.4142,1.4142,3.608-3.6082M14,2v2h12.5713s-4.5847,4.5858-4.5847,4.5858l1.4142,1.4142,4.5992-4.5847v12.5847h2l-.0134-16h-15.9866Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Dependency.propTypes = iconPropTypes;
}
const Deploy = /*#__PURE__*/React.forwardRef(function Deploy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Deploy.propTypes = iconPropTypes;
}
const DeployRules = /*#__PURE__*/React.forwardRef(function DeployRules({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H15V20H8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H24V24H8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H24V28H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeployRules.propTypes = iconPropTypes;
}
const DeploymentCanary = /*#__PURE__*/React.forwardRef(function DeploymentCanary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "11",
    r: "1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4632,7.4637c-.9373-.9372-2.2085-1.4637-3.534-1.4637h-.0107c-1.319,0-2.584.524-3.5167,1.4567l-2.9076,2.9076L8.4181,2.2855c-.3805-.3806-.9976-.3806-1.3781,0l-.5519.5521c-3.3182,3.3195-3.3174,8.7003.0017,12.0189l3.1455,3.145L1.0509,26.5858l1.4141,1.4142,9.9984-9.9985-4.5596-4.5591c-2.4756-2.4761-2.5327-6.4688-.1714-9.0142l8.3573,8.3603c1.223,1.2234,1.2228,3.2066-.0004,4.4298l-.7964.7964,1.4141,1.4141.7964-.7964c1.8623-1.8628,1.9683-4.7998.3638-6.813l2.9406-2.9406c.5626-.5626,1.3257-.8787,2.1214-.8787h0c.7952,0,1.5579.3159,2.1203.8781l2.1224,2.1219c-1.4878,1.4873-5.1719,5.1699-5.1719,5.1699v2.8301c0,3.866-3.134,7-7,7h-3v2h3c4.9706,0,9-4.0294,9-9v-2.0586c.7607-.7021,6-5.9414,6-5.9414l-3.5368-3.5363Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentCanary.propTypes = iconPropTypes;
}
const DeploymentPattern = /*#__PURE__*/React.forwardRef(function DeploymentPattern({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4.73A1.9735,1.9735,0,0,0,3,19a2,2,0,0,0,0,4A1.9735,1.9735,0,0,0,4.73,22H8Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29,9a1.9735,1.9735,0,0,0-1.73,1H24v2h3.27A1.9991,1.9991,0,1,0,29,9Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4141,5,21,.5859,16.5859,5,20,8.4141V18h2V8.4141ZM21,3.4141,22.5859,5,21,6.5859,19.4141,5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23.5859V14H10v9.5859L6.5859,27,11,31.4141,15.4141,27ZM9.4141,27,11,25.4141,12.5859,27,11,28.5859Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13,3A2,2,0,0,0,9,3,1.9733,1.9733,0,0,0,10,4.73V8h2V4.73A1.9733,1.9733,0,0,0,13,3Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27.2705V24H20v3.27a2,2,0,1,0,2,0Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentPattern.propTypes = iconPropTypes;
}
const DeploymentPolicy = /*#__PURE__*/React.forwardRef(function DeploymentPolicy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20.1011V18a4.0045,4.0045,0,0,0-4-4H5.8281l2.293-2.293L6.707,10.293,2,15l4.707,4.707,1.4141-1.414L5.8281,16H13a2.0025,2.0025,0,0,1,2,2v2.1011a5,5,0,1,0,2,0ZM16,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentPolicy.propTypes = iconPropTypes;
}
const DeploymentUnitData = /*#__PURE__*/React.forwardRef(function DeploymentUnitData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitData.propTypes = iconPropTypes;
}
const DeploymentUnitExecution = /*#__PURE__*/React.forwardRef(function DeploymentUnitExecution({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitExecution.propTypes = iconPropTypes;
}
const DeploymentUnitInstallation = /*#__PURE__*/React.forwardRef(function DeploymentUnitInstallation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitInstallation.propTypes = iconPropTypes;
}
const DeploymentUnitPresentation = /*#__PURE__*/React.forwardRef(function DeploymentUnitPresentation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitPresentation.propTypes = iconPropTypes;
}
const DeploymentUnitTechnicalData = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21,23H17V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,21,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H19Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalData.propTypes = iconPropTypes;
}
const DeploymentUnitTechnicalExecution = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalExecution({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalExecution.propTypes = iconPropTypes;
}
const DeploymentUnitTechnicalInstallation = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalInstallation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalInstallation.propTypes = iconPropTypes;
}
const DeploymentUnitTechnicalPresentation = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalPresentation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M19,23H17V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H19Zm0-7h4V10.9985H19Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalPresentation.propTypes = iconPropTypes;
}
const DeskAdjustable = /*#__PURE__*/React.forwardRef(function DeskAdjustable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12H2v8H4V30H6V20H26V30h2V20h2Zm-2,6H4V14H28Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DeskAdjustable.propTypes = iconPropTypes;
}
const Development = /*#__PURE__*/React.forwardRef(function Development({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4V8H4V4H8M2,2v8h8V2Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7v4H14V7h4M12,5v8h8V5Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16v4H4V16H8M2,14v8h8V14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Development.propTypes = iconPropTypes;
}
const Devices = /*#__PURE__*/React.forwardRef(function Devices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Devices.propTypes = iconPropTypes;
}
const DevicesApps = /*#__PURE__*/React.forwardRef(function DevicesApps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V12H26z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H24V6H20z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H24V12H20z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m28,20h-14v2h2v4h-2v2h9v-2h-5v-4h10c.5304,0,1.0392-.2108,1.4142-.5858s.5858-.8838.5858-1.4142v-6h-2v6Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m6,6h12v-2H6c-.5304,0-1.0392.2107-1.4142.5858-.3751.375-.5858.8838-.5858,1.4142v6h2v-6Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m10,14H4c-.5304,0-1.0392.2107-1.4142.5858-.3751.375-.5858.8838-.5858,1.4142v12c0,.5304.2107,1.0392.5858,1.4142.375.375.8838.5858,1.4142.5858h6c.5304,0,1.0392-.2108,1.4142-.5858.3751-.375.5858-.8838.5858-1.4142v-12c0-.5304-.2107-1.0392-.5858-1.4142-.375-.3751-.8838-.5858-1.4142-.5858Zm0,14H4v-12h6v12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DevicesApps.propTypes = iconPropTypes;
}
const DewPoint = /*#__PURE__*/React.forwardRef(function DewPoint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,4Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,30A5.4962,5.4962,0,0,1,9,24.52c0-3.4426,4.3442-21.0141,4.5293-21.76a1,1,0,0,1,1.9414,0C15.6558,3.5059,20,21.0774,20,24.52A5.4962,5.4962,0,0,1,14.5,30Zm0-22.7561C13.0391,13.38,11,22.4089,11,24.52a3.5,3.5,0,0,0,7,0C18,22.4089,15.9609,13.38,14.5,7.2439Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DewPoint.propTypes = iconPropTypes;
}
const DewPointFilled = /*#__PURE__*/React.forwardRef(function DewPointFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,4Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,30A5.4962,5.4962,0,0,1,9,24.52c0-3.4426,4.3442-21.0141,4.5293-21.76a1,1,0,0,1,1.9414,0C15.6558,3.5059,20,21.0774,20,24.52A5.4962,5.4962,0,0,1,14.5,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DewPointFilled.propTypes = iconPropTypes;
}
const Diagram = /*#__PURE__*/React.forwardRef(function Diagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Diagram.propTypes = iconPropTypes;
}
const DiagramReference = /*#__PURE__*/React.forwardRef(function DiagramReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DiagramReference.propTypes = iconPropTypes;
}
const DiamondOutline = /*#__PURE__*/React.forwardRef(function DiamondOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.3906,14.5269L17.4731,2.6094c-.406-.4062-.9397-.6094-1.4731-.6094s-1.0671.2031-1.4731.6094L2.6094,14.5269c-.4062.4062-.6094.9395-.6094,1.4731s.2031,1.0669.6094,1.4731l11.9175,11.9175c.406.4062.9397.6094,1.4731.6094s1.0671-.2031,1.4731-.6094l11.9175-11.9175c.4062-.4062.6094-.9395.6094-1.4731s-.2031-1.0669-.6094-1.4731Zm-13.3906,13.5088L3.9646,16,16,3.9644l12.0356,12.0356-12.0356,12.0356Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DiamondOutline.propTypes = iconPropTypes;
}
const DiamondSolid = /*#__PURE__*/React.forwardRef(function DiamondSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.3906,14.5269L17.4731,2.6094c-.406-.4062-.9397-.6094-1.4731-.6094s-1.0671.2031-1.4731.6094L2.6094,14.5269c-.4062.4062-.6094.9395-.6094,1.4731s.2031,1.0669.6094,1.4731l11.9175,11.9175c.406.4062.9397.6094,1.4731.6094s1.0671-.2031,1.4731-.6094l11.9175-11.9175c.4062-.4062.6094-.9395.6094-1.4731s-.2031-1.0669-.6094-1.4731Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DiamondSolid.propTypes = iconPropTypes;
}
const DiamondFill = /*#__PURE__*/React.forwardRef(function DiamondFill({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z"
    })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142M8,1,1,8l7,7,7-7L8,1Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2.4142,13.5858,8,8,13.5858,2.4142,8,8,2.4142"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DiamondFill.propTypes = iconPropTypes;
}
const WatsonHealthDicom_6000 = /*#__PURE__*/React.forwardRef(function WatsonHealthDicom_6000({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M13,11H7a3,3,0,0,0-3,3v2H6V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,13,11Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10A4,4,0,1,0,6,6,4,4,0,0,0,10,10Zm0-6A2,2,0,1,1,8,6,2,2,0,0,1,10,4Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H30V6H20z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H30V10H20z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H26V14H20z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M5,30H3a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H6v2H3v2H5a2,2,0,0,1,2,2v2A2,2,0,0,1,5,30ZM3,26v2H5V26Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30H11a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,13,30Zm-2-8v6h2V22Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H19a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,21,30Zm-2-8v6h2V22Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H27a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,29,30Zm-2-8v6h2V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDicom_6000.propTypes = iconPropTypes;
}
const WatsonHealthDicomOverlay = /*#__PURE__*/React.forwardRef(function WatsonHealthDicomOverlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H12V18H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDicomOverlay.propTypes = iconPropTypes;
}
const DirectLink = /*#__PURE__*/React.forwardRef(function DirectLink({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["DirectLink"]) {
      didWarnAboutDeprecation["DirectLink"] = true;
      console.warn("The current icon has been replaced with the correct version of the App icon, use the most appropriate ibm-cloud--direct-link icon variant instead. As a result, the DirectLink component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectLink.propTypes = iconPropTypes;
}
const DirectionBearRight_01 = /*#__PURE__*/React.forwardRef(function DirectionBearRight_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_01.propTypes = iconPropTypes;
}
const DirectionBearRight_01Filled = /*#__PURE__*/React.forwardRef(function DirectionBearRight_01Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_01Filled.propTypes = iconPropTypes;
}
const DirectionBearRight_02 = /*#__PURE__*/React.forwardRef(function DirectionBearRight_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.55H10.5V13.45H8.5z",
    transform: "rotate(-45 9.5 9.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_02.propTypes = iconPropTypes;
}
const DirectionBearRight_02Filled = /*#__PURE__*/React.forwardRef(function DirectionBearRight_02Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_02Filled.propTypes = iconPropTypes;
}
const DirectionCurve = /*#__PURE__*/React.forwardRef(function DirectionCurve({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionCurve.propTypes = iconPropTypes;
}
const DirectionCurveFilled = /*#__PURE__*/React.forwardRef(function DirectionCurveFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionCurveFilled.propTypes = iconPropTypes;
}
const DirectionFork = /*#__PURE__*/React.forwardRef(function DirectionFork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionFork.propTypes = iconPropTypes;
}
const DirectionForkFilled = /*#__PURE__*/React.forwardRef(function DirectionForkFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
    "data-icon-path": "inner-path"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionForkFilled.propTypes = iconPropTypes;
}
const DirectionLoopLeft = /*#__PURE__*/React.forwardRef(function DirectionLoopLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V28H16z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionLoopLeft.propTypes = iconPropTypes;
}
const DirectionLoopLeftFilled = /*#__PURE__*/React.forwardRef(function DirectionLoopLeftFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
    "data-icon-path": "inner-path"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionLoopLeftFilled.propTypes = iconPropTypes;
}
const DirectionLoopRight = /*#__PURE__*/React.forwardRef(function DirectionLoopRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V28H14z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionLoopRight.propTypes = iconPropTypes;
}
const DirectionLoopRightFilled = /*#__PURE__*/React.forwardRef(function DirectionLoopRightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
    "data-icon-path": "inner-path"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionLoopRightFilled.propTypes = iconPropTypes;
}
const DirectionMerge = /*#__PURE__*/React.forwardRef(function DirectionMerge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionMerge.propTypes = iconPropTypes;
}
const DirectionMergeFilled = /*#__PURE__*/React.forwardRef(function DirectionMergeFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionMergeFilled.propTypes = iconPropTypes;
}
const DirectionRight_01 = /*#__PURE__*/React.forwardRef(function DirectionRight_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRight_01.propTypes = iconPropTypes;
}
const DirectionRight_01Filled = /*#__PURE__*/React.forwardRef(function DirectionRight_01Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRight_01Filled.propTypes = iconPropTypes;
}
const DirectionRight_02 = /*#__PURE__*/React.forwardRef(function DirectionRight_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19,8,17.5859,9.4141,22.1719,14H10a2,2,0,0,0-2,2V28h2V16H22.1719l-4.586,4.5859L19,22l7-7Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H10V12H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRight_02.propTypes = iconPropTypes;
}
const DirectionRight_02Filled = /*#__PURE__*/React.forwardRef(function DirectionRight_02Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRight_02Filled.propTypes = iconPropTypes;
}
const DirectionRotaryFirstRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRight.propTypes = iconPropTypes;
}
const DirectionRotaryFirstRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRightFilled.propTypes = iconPropTypes;
}
const DirectionRotaryRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRight.propTypes = iconPropTypes;
}
const DirectionRotaryRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryRightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRightFilled.propTypes = iconPropTypes;
}
const DirectionRotaryStraight = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraight.propTypes = iconPropTypes;
}
const DirectionRotaryStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "19",
    r: "3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraightFilled.propTypes = iconPropTypes;
}
const DirectionSharpTurn = /*#__PURE__*/React.forwardRef(function DirectionSharpTurn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurn.propTypes = iconPropTypes;
}
const DirectionSharpTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionSharpTurnFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurnFilled.propTypes = iconPropTypes;
}
const DirectionStraight = /*#__PURE__*/React.forwardRef(function DirectionStraight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraight.propTypes = iconPropTypes;
}
const DirectionStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightFilled.propTypes = iconPropTypes;
}
const DirectionStraightRight = /*#__PURE__*/React.forwardRef(function DirectionStraightRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightRight.propTypes = iconPropTypes;
}
const DirectionStraightRightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightRightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightRightFilled.propTypes = iconPropTypes;
}
const DirectionUTurn = /*#__PURE__*/React.forwardRef(function DirectionUTurn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionUTurn.propTypes = iconPropTypes;
}
const DirectionUTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionUTurnFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
    "data-icon-path": "inner-path"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionUTurnFilled.propTypes = iconPropTypes;
}
const DirectoryDomain = /*#__PURE__*/React.forwardRef(function DirectoryDomain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectoryDomain.propTypes = iconPropTypes;
}
const DistributeHorizontalCenter = /*#__PURE__*/React.forwardRef(function DistributeHorizontalCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10H23V2H21v8H20a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2h1v8h2V22h1a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,24,10Zm0,10H20V12h4Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6H11V2H9V6H8A2.0023,2.0023,0,0,0,6,8V24a2.0023,2.0023,0,0,0,2,2H9v4h2V26h1a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,12,6Zm0,18H8V8h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalCenter.propTypes = iconPropTypes;
}
const DistributeHorizontalLeft = /*#__PURE__*/React.forwardRef(function DistributeHorizontalLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H24a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM24,12v8h4V12Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H20V30H18z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6h4a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,12,26ZM8,8V24h4V8Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V30H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalLeft.propTypes = iconPropTypes;
}
const DistributeHorizontalRight = /*#__PURE__*/React.forwardRef(function DistributeHorizontalRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22H20a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,24,22ZM20,12h-.0015L20,20h4V12Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V30H12z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,8,26ZM4,8H3.9985L4,24H8V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalRight.propTypes = iconPropTypes;
}
const DistributeVerticalBottom = /*#__PURE__*/React.forwardRef(function DistributeVerticalBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H8a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,26Zm0-6.0012L8,20v4H24Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H30V14H2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10H12a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,20,10Zm0-6.0012L12,4V8h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalBottom.propTypes = iconPropTypes;
}
const DistributeVerticalCenter = /*#__PURE__*/React.forwardRef(function DistributeVerticalCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M30,21H26V20a2.0023,2.0023,0,0,0-2-2H8a2.0023,2.0023,0,0,0-2,2v1H2v2H6v1a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V23h4Zm-6,3H8V20l16-.001Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M30,9H22V8a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V9H2v2h8v1a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V11h8ZM20,12H12V8l8-.001Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalCenter.propTypes = iconPropTypes;
}
const DistributeVerticalTop = /*#__PURE__*/React.forwardRef(function DistributeVerticalTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,30ZM8,24v4H24V24Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H30V20H2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14H12a2.0021,2.0021,0,0,1-2-2V8a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,20,14ZM12,8v4h8V8Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H30V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalTop.propTypes = iconPropTypes;
}
const WatsonHealthDna = /*#__PURE__*/React.forwardRef(function WatsonHealthDna({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDna.propTypes = iconPropTypes;
}
const DnsServices = /*#__PURE__*/React.forwardRef(function DnsServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H26V26H20z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DnsServices.propTypes = iconPropTypes;
}
const Doc = /*#__PURE__*/React.forwardRef(function Doc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24V21h6Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.002,2.002,0,0,1,2,2V21A2.0023,2.0023,0,0,1,18,23ZM14,11V21h4V11Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M6,23H2V9H6a4.0045,4.0045,0,0,1,4,4v6A4.0045,4.0045,0,0,1,6,23ZM4,21H6a2.002,2.002,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Doc.propTypes = iconPropTypes;
}
const Document = /*#__PURE__*/React.forwardRef(function Document({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3 z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H22V24H10z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Document.propTypes = iconPropTypes;
}
const DocumentAdd = /*#__PURE__*/React.forwardRef(function DocumentAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAdd.propTypes = iconPropTypes;
}
const DocumentAttachment = /*#__PURE__*/React.forwardRef(function DocumentAttachment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H24V12H17z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H24V17H16z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H24V22H15z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M9,19a5.0055,5.0055,0,0,1-5-5V3H6V14a3,3,0,0,0,6,0V5a1,1,0,0,0-2,0V15H8V5a3,3,0,0,1,6,0v9A5.0055,5.0055,0,0,1,9,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAttachment.propTypes = iconPropTypes;
}
const DocumentAudio = /*#__PURE__*/React.forwardRef(function DocumentAudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAudio.propTypes = iconPropTypes;
}
const DocumentBlank = /*#__PURE__*/React.forwardRef(function DocumentBlank({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentBlank.propTypes = iconPropTypes;
}
const DocumentComment = /*#__PURE__*/React.forwardRef(function DocumentComment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,17h-10c-1.104.0014-1.9986.896-2,2v6c0,1.1046.8954,2,2,2h4v-2h-4v-6h10v6h-2.5352l-2.5937,3.8906,1.6641,1.1094,2-3h1.4648c1.1046,0,2-.8954,2-2v-6c-.0014-1.104-.896-1.9986-2-2Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,14h2v-4c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998H6c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h6v-2h-6V4h8v6c0,1.1001.8999,2,2,2h6v2Zm-6-4v-5.6001l5.6001,5.6001h-5.6001Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentComment.propTypes = iconPropTypes;
}
const DocumentConfiguration = /*#__PURE__*/React.forwardRef(function DocumentConfiguration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,24v-2h-2.1011c-.1289-.6259-.3775-1.2211-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49c-.5318-.3545-1.127-.603-1.753-.732v-2.1011h-2v2.1011c-.6259.1289-1.2211.3775-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49c-.3545.5318-.603,1.127-.732,1.753h-2.1011v2h2.1011c.1289.6259.3775,1.2211.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49c.5318.3545,1.127.603,1.753.732v2.1011h2v-2.1011c.6259-.1289,1.2211-.3775,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49c.3545-.5318.603-1.127.732-1.753h2.1011Zm-7,2c-1.6569,0-3-1.3431-3-3s1.3431-3,3-3,3,1.3431,3,3c-.0018,1.6561-1.3439,2.9982-3,3Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.499,9.085l-6.792-6.792c-.1875-.1875-.4419-.293-.707-.293H6c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h8v-2H6V4h8v6c0,1.1025.897,2,2,2h6.292c.6929,0,1.312-.4136,1.5771-1.0537.2656-.6406.1201-1.3711-.3701-1.8613Zm-7.499.915v-5.5859l5.5854,5.5859h-5.5854Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentConfiguration.propTypes = iconPropTypes;
}
const DocumentDownload = /*#__PURE__*/React.forwardRef(function DocumentDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentDownload.propTypes = iconPropTypes;
}
const DocumentEpdf = /*#__PURE__*/React.forwardRef(function DocumentEpdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentEpdf.propTypes = iconPropTypes;
}
const DocumentExport = /*#__PURE__*/React.forwardRef(function DocumentExport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentExport.propTypes = iconPropTypes;
}
const DocumentHorizontal = /*#__PURE__*/React.forwardRef(function DocumentHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentHorizontal.propTypes = iconPropTypes;
}
const DocumentImport = /*#__PURE__*/React.forwardRef(function DocumentImport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentImport.propTypes = iconPropTypes;
}
const DocumentMultiple_01 = /*#__PURE__*/React.forwardRef(function DocumentMultiple_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H4V26H2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V28H6z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H26V24H14z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H26V18H14z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,9.3l-7-7C22.5,2.1,22.3,2,22,2H12c-1.1,0-2,0.9-2,2v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10 C30,9.7,29.9,9.5,29.7,9.3z M22,4.4l5.6,5.6H22V4.4z M28,28H12V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentMultiple_01.propTypes = iconPropTypes;
}
const DocumentMultiple_02 = /*#__PURE__*/React.forwardRef(function DocumentMultiple_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M18,31H6c-1.1,0-2-0.9-2-2V12h2v17h12V31z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27H10c-1.1,0-2-0.9-2-2V8h2v17h12V27z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H24V18H16z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7C20.5,2.1,20.3,2,20,2h-6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10 C28,9.7,27.9,9.5,27.7,9.3z M20,4.4l5.6,5.6H20V4.4z M26,21H14V4h4v6c0,1.1,0.9,2,2,2h6V21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentMultiple_02.propTypes = iconPropTypes;
}
const DocumentPdf = /*#__PURE__*/React.forwardRef(function DocumentPdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26H15V16h4a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,19,26Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V19a1.0011,1.0011,0,0,0-1-1H17Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16H6V26H8V23h3a2.0027,2.0027,0,0,0,2-2V18A2.0023,2.0023,0,0,0,11,16ZM8,21V18h3l.001,3Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentPdf.propTypes = iconPropTypes;
}
const DocumentPreliminary = /*#__PURE__*/React.forwardRef(function DocumentPreliminary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H16V24H8z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentPreliminary.propTypes = iconPropTypes;
}
const DocumentProcessor = /*#__PURE__*/React.forwardRef(function DocumentProcessor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28v2h-2c-1.1025,0-2-.8975-2-2v-2h2v2h2Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26h2v2c0,1.1025-.8975,2-2,2h-2v-2h2v-2Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21v-2h2c1.1025,0,2,.8975,2,2v2h-2v-2h-2Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M19,23h-2v-2c0-1.1025.8975-2,2-2h2v2h-2v2Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28h-6V4h8v6c0,1.1001.8999,2,2,2h6v4h2v-6c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998h-10c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h6v-2ZM18,4.3999l5.6001,5.6001h-5.6001v-5.6001Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentProcessor.propTypes = iconPropTypes;
}
const DocumentProtected = /*#__PURE__*/React.forwardRef(function DocumentProtected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentProtected.propTypes = iconPropTypes;
}
const DocumentRequirements = /*#__PURE__*/React.forwardRef(function DocumentRequirements({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M28.5899 20.59L22 27.1798 19.41 24.5898 18 26 22 30 30 22 28.5899 20.59z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 20H16V22H10z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 16H18V18H10z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,4h8v6c0,1.1001.8999,2,2,2h6v6h2v-8c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998h-10c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h7v-2h-7V4Zm10,.3999l5.6001,5.6001h-5.6001v-5.6001Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentRequirements.propTypes = iconPropTypes;
}
const DocumentSecurity = /*#__PURE__*/React.forwardRef(function DocumentSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSecurity.propTypes = iconPropTypes;
}
const DocumentSigned = /*#__PURE__*/React.forwardRef(function DocumentSigned({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H12V26H8z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSigned.propTypes = iconPropTypes;
}
const DocumentSketch = /*#__PURE__*/React.forwardRef(function DocumentSketch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSketch.propTypes = iconPropTypes;
}
const DocumentSubject = /*#__PURE__*/React.forwardRef(function DocumentSubject({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,30h-5v-2h5v-2h-3c-1.1025,0-2-.8975-2-2v-2c0-1.103.8975-2,2-2h5v2h-5v2h3c1.1025,0,2,.8975,2,2v2c0,1.1025-.8975,2-2,2Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 20H16V22H10z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 16H18V18H10z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,16.9922h2v-6.9922c0-.1001,0-.2998-.1001-.3999-.0999-.1001-.0999-.2002-.2-.3003l-7-7c-.0999-.0996-.2-.1997-.3-.1997-.0999-.1001-.2998-.1001-.3999-.1001h-10c-.5,0-1,.2002-1.3999.6001-.4001.3999-.6001.8999-.6001,1.3999v24c0,.5.2,1,.6001,1.3999.3999.3999.8999.6001,1.3999.6001h7.9473v-2h-7.9473V4h8v6c0,.5.2,1,.6001,1.3999.3999.3999.8999.6001,1.3999.6001h6v4.9922Zm-6-6.9922v-5.6001l5.6001,5.6001h-5.6001Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSubject.propTypes = iconPropTypes;
}
const DocumentSubtract = /*#__PURE__*/React.forwardRef(function DocumentSubtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSubtract.propTypes = iconPropTypes;
}
const DocumentTasks = /*#__PURE__*/React.forwardRef(function DocumentTasks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentTasks.propTypes = iconPropTypes;
}
const DocumentUnknown = /*#__PURE__*/React.forwardRef(function DocumentUnknown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "28.5",
    r: "1.5"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentUnknown.propTypes = iconPropTypes;
}
const DocumentUnprotected = /*#__PURE__*/React.forwardRef(function DocumentUnprotected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentUnprotected.propTypes = iconPropTypes;
}
const DocumentVertical = /*#__PURE__*/React.forwardRef(function DocumentVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentVertical.propTypes = iconPropTypes;
}
const DocumentVideo = /*#__PURE__*/React.forwardRef(function DocumentVideo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentVideo.propTypes = iconPropTypes;
}
const DocumentView = /*#__PURE__*/React.forwardRef(function DocumentView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentView.propTypes = iconPropTypes;
}
const DocumentWordProcessor = /*#__PURE__*/React.forwardRef(function DocumentWordProcessor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessor.propTypes = iconPropTypes;
}
const DocumentWordProcessorReference = /*#__PURE__*/React.forwardRef(function DocumentWordProcessorReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V16H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,10V4.4141L23.5859,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessorReference.propTypes = iconPropTypes;
}
const DocumentSentiment = /*#__PURE__*/React.forwardRef(function DocumentSentiment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSentiment.propTypes = iconPropTypes;
}
const Documentation = /*#__PURE__*/React.forwardRef(function Documentation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,9.4912l-8.0041-6.997c-.3644-.3186-.8322-.4942-1.3163-.4942H4c-1.1046,0-2,.8954-2,2v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V10.997c0-.577-.2493-1.126-.6837-1.5058ZM28,13v15H4V4h14v7c0,1.1046.8954,2,2,2l8,.0012M6,14h4.3682c3.1294,0,5.1758,2.0088,5.1758,5.998s-2.0464,6.002-5.1758,6.002h-4.3682v-12ZM10.3682,23.9883c1.6851,0,2.7686-.998,2.7686-3.0439v-1.8887c0-2.0469-1.0835-3.0439-2.7686-3.0439h-2.0981v7.9766h2.0981ZM17,21.4941c0-2.8711,1.5991-4.6768,4.1611-4.6768,2.5796,0,4.1792,1.8057,4.1792,4.6768,0,2.8896-1.5996,4.7119-4.1792,4.7119-2.562,0-4.1611-1.8223-4.1611-4.7119ZM23.0356,22.3369v-1.668c0-1.3408-.7222-2.0811-1.8745-2.0811-1.1348,0-1.8569.7402-1.8569,2.0811v1.668c0,1.3584.7222,2.0986,1.8569,2.0986,1.1523,0,1.8745-.7402,1.8745-2.0986Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Documentation.propTypes = iconPropTypes;
}
const DogWalker = /*#__PURE__*/React.forwardRef(function DogWalker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V30H20z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H6V30H4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V26a1.0011,1.0011,0,0,0-1-1H11v5H9V23h4a3.0033,3.0033,0,0,1,3,3Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,22A3.5041,3.5041,0,0,1,4,18.5V17H2V15H6v3.5a1.5,1.5,0,0,0,3,0V15h4v2H11v1.5A3.5041,3.5041,0,0,1,7.5,22Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M27,10H21.354a2.9861,2.9861,0,0,0-2.7856,1.8857l-1.4419,3.6055-3.6079,4.51,1.562,1.249,3.7-4.625,1.645-3.9961A.9949.9949,0,0,1,21.354,12H27a1.0009,1.0009,0,0,1,1,1v7H25V30h2V22h1a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,27,10Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DogWalker.propTypes = iconPropTypes;
}
const DotMark = /*#__PURE__*/React.forwardRef(function DotMark({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "8"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DotMark.propTypes = iconPropTypes;
}
const DoubleAxisChartBar = /*#__PURE__*/React.forwardRef(function DoubleAxisChartBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4v-2H4c-1.1047,0-2,.8955-2,2v24c0,1.1045.8953,2,2,2h26v-2H4v-3h22v-7H4v-4h14v-7H4v-3h26ZM24,20v3H4v-3h20ZM16,9v3H4v-3h12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DoubleAxisChartBar.propTypes = iconPropTypes;
}
const DoubleAxisChartColumn = /*#__PURE__*/React.forwardRef(function DoubleAxisChartColumn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2v26h-3V6h-7v22h-4v-14h-7v14h-3V2h-2v26c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V2h-2ZM12,28h-3v-12h3v12ZM23,28h-3V8h3v20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DoubleAxisChartColumn.propTypes = iconPropTypes;
}

export { DatabaseRedis, Datastore, Db2BufferPool, Db2DataSharingGroup, Db2Database, Debug, DecisionNode, DecisionTree, Delete, Delivery, DeliveryAdd, DeliveryParcel, DeliverySettings, DeliveryTruck, Demo, Departure, Dependency, Deploy, DeployRules, DeploymentCanary, DeploymentPattern, DeploymentPolicy, DeploymentUnitData, DeploymentUnitExecution, DeploymentUnitInstallation, DeploymentUnitPresentation, DeploymentUnitTechnicalData, DeploymentUnitTechnicalExecution, DeploymentUnitTechnicalInstallation, DeploymentUnitTechnicalPresentation, DeskAdjustable, Development, Devices, DevicesApps, DewPoint, DewPointFilled, Diagram, DiagramReference, DiamondFill, DiamondOutline, DiamondSolid, DirectLink, DirectionBearRight_01, DirectionBearRight_01Filled, DirectionBearRight_02, DirectionBearRight_02Filled, DirectionCurve, DirectionCurveFilled, DirectionFork, DirectionForkFilled, DirectionLoopLeft, DirectionLoopLeftFilled, DirectionLoopRight, DirectionLoopRightFilled, DirectionMerge, DirectionMergeFilled, DirectionRight_01, DirectionRight_01Filled, DirectionRight_02, DirectionRight_02Filled, DirectionRotaryFirstRight, DirectionRotaryFirstRightFilled, DirectionRotaryRight, DirectionRotaryRightFilled, DirectionRotaryStraight, DirectionRotaryStraightFilled, DirectionSharpTurn, DirectionSharpTurnFilled, DirectionStraight, DirectionStraightFilled, DirectionStraightRight, DirectionStraightRightFilled, DirectionUTurn, DirectionUTurnFilled, DirectoryDomain, DistributeHorizontalCenter, DistributeHorizontalLeft, DistributeHorizontalRight, DistributeVerticalBottom, DistributeVerticalCenter, DistributeVerticalTop, DnsServices, Doc, Document, DocumentAdd, DocumentAttachment, DocumentAudio, DocumentBlank, DocumentComment, DocumentConfiguration, DocumentDownload, DocumentEpdf, DocumentExport, DocumentHorizontal, DocumentImport, DocumentMultiple_01, DocumentMultiple_02, DocumentPdf, DocumentPreliminary, DocumentProcessor, DocumentProtected, DocumentRequirements, DocumentSecurity, DocumentSentiment, DocumentSigned, DocumentSketch, DocumentSubject, DocumentSubtract, DocumentTasks, DocumentUnknown, DocumentUnprotected, DocumentVertical, DocumentVideo, DocumentView, DocumentWordProcessor, DocumentWordProcessorReference, Documentation, DogWalker, DotMark, DoubleAxisChartBar, DoubleAxisChartColumn, WatsonHealthDenominate, WatsonHealthDicomOverlay, WatsonHealthDicom_6000, WatsonHealthDna };
